import { CSS } from '@grupoboticario/flora-react'

export const loaderContainerCss = (height: number | string): CSS => ({
  height
})
